(function () {
  'use strict';

  // Only applies at tablet/desktop where slider--mobile doesn't actually scroll
  var mql = window.matchMedia('(min-width: 750px)');

  function initGalleryNav(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    var thumbnailsEl = gallery.querySelector('[id^="GalleryThumbnails-"]');
    if (!viewer || !thumbnailsEl) return;

    var prevBtn = viewer.querySelector('button[name="previous"]');
    var nextBtn = viewer.querySelector('button[name="next"]');
    var sliderBtns = viewer.querySelector('.slider-buttons');
    if (!prevBtn || !nextBtn || !sliderBtns) return;

    // ── Thumbnail navigation helpers ─────────────────────────────────

    function getThumbnailBtns() {
      return Array.from(thumbnailsEl.querySelectorAll('.thumbnail-list__item button'));
    }

    function getActiveIdx(btns) {
      return btns.findIndex(function (b) {
        return b.getAttribute('aria-current') === 'true';
      });
    }

    function syncDisabledState(btns, idx) {
      if (idx <= 0) prevBtn.setAttribute('disabled', '');
      else prevBtn.removeAttribute('disabled');
      if (idx >= btns.length - 1) nextBtn.setAttribute('disabled', '');
      else nextBtn.removeAttribute('disabled');
    }

    // Wire prev/next buttons to thumbnail navigation
    prevBtn.addEventListener('click', function () {
      if (!mql.matches) return;
      var btns = getThumbnailBtns();
      var idx = getActiveIdx(btns);
      if (idx > 0) btns[idx - 1].click();
    });

    nextBtn.addEventListener('click', function () {
      if (!mql.matches) return;
      var btns = getThumbnailBtns();
      var idx = getActiveIdx(btns);
      if (idx < btns.length - 1) btns[idx + 1].click();
    });

    // ── Button overlay positioning ───────────────────────────────────

    function positionButtons() {
      if (!mql.matches) {
        sliderBtns.style.left = '';
        sliderBtns.style.right = '';
        sliderBtns.style.top = '';
        sliderBtns.style.transform = '';
        return;
      }

      var activeItem = viewer.querySelector('.product__media-item.is-active');
      var container = activeItem && activeItem.querySelector('.product-media-container');
      if (!container) return;

      var cr = container.getBoundingClientRect();
      var vr = viewer.getBoundingClientRect();
      if (cr.width === 0 || vr.width === 0) return;

      var centerY = cr.top - vr.top + cr.height / 2 - sliderBtns.offsetHeight / 2;

      sliderBtns.style.left = (cr.left - vr.left) + 'px';
      sliderBtns.style.right = (vr.right - cr.right) + 'px';
      sliderBtns.style.top = centerY + 'px';
      sliderBtns.style.transform = 'none';

      var btns = getThumbnailBtns();
      syncDisabledState(btns, getActiveIdx(btns));
    }

    // Re-position when the active slide changes (class mutation)
    new MutationObserver(function () {
      requestAnimationFrame(positionButtons);
    }).observe(viewer, { attributes: true, attributeFilter: ['class'], subtree: true });

    window.addEventListener('resize', positionButtons);

    // Wait for layout and images to settle before first position
    var img = viewer.querySelector('.product__media-item.is-active img');
    if (img && !img.complete) {
      img.addEventListener('load', positionButtons, { once: true });
    }
    setTimeout(positionButtons, 150);
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(initGalleryNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
